export default __webpack_public_path__ + "static/media/14.d39e3789.png";